import { BehaviorSubject } from "rxjs/Rx";
import { Component } from '@angular/core';
import { Events, IonicPage, ModalController, NavController, NavParams, ViewController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage';

import { fadeInOutAnimation } from '../../animations/fade-in-out';
import { OrderList } from '../../models/order-list.model';

import { OrderProvider } from "../../providers/order/order";

import { OrderDetailPage } from '../order-detail/order-detail';
import { LoginPage } from '../auth/login';

import { listAnimation } from '../../animations/list-animation';

@IonicPage()
@Component({
  selector: 'page-orders-list',
  templateUrl: 'orders-list.html',
  animations: [
    fadeInOutAnimation,
    listAnimation
  ]
})
export class OrdersListPage {

  public ordersList: Array<OrderList> = new Array();

  private modal;
  private detailModal;

  public loading: boolean;

  public brand_name: String;
  public orderList: Array<OrderList>;

  public currentPage: String;
  public subscriberEnter;

  public inOrdersList: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor(public storage: Storage, public events: Events, public orderProvider: OrderProvider, public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController, public translate: TranslateService, public modalCtrl: ModalController) {
    let eventCallBack:any = (data) => {
      this.ordersList = data;
      this.loading = false;
    }
    this.loading = true;
    events.subscribe('orderList:refresh', eventCallBack);

    this.subscriberEnter = this.navCtrl.viewDidEnter.subscribe((view) => {
      if (!this.currentPage) {
        this.currentPage = view.instance.constructor.name;
      }

      if ((this.currentPage == 'PosmItemsPage'
      && view.instance.constructor.name == 'PosmCategoriesPage')
      ||
      (this.currentPage == 'PosmSubitemsPage'
      && (view.instance.constructor.name == 'PosmCategoriesPage' || view.instance.constructor.name == 'PosmItemsPage'))
      ||
      (this.currentPage == 'ModalCmp'
      && (view.instance.constructor.name == 'PosmCategoriesPage' || view.instance.constructor.name == 'PosmItemsPage' || view.instance.constructor.name == 'PosmSubitemsPage'))) {
        events.unsubscribe('orderList:refresh', eventCallBack);
        this.subscriberEnter.unsubscribe();
      }
    });
  }

  closeModal() {
    this.navCtrl.pop();
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }


  get ordersListLength () {
    return (this.ordersList? this.ordersList.length : 0);
  }

  get ordersListNotificationsLength () {
    let notificationsLength = 0;
    for (let order of this.ordersList) {
      if (order.notification == true) {
        notificationsLength++;
      }
    }
    return notificationsLength;
  }

  protected reloadOrdersListContent (refresher) {
    this.events.publish('orderList:get_data');
    refresher.complete();
  }

  showOrdersList() {
    this.inOrdersList.next(true);
    this.storage.get('current_brand').then((brand) => {
      this.modal = this.modalCtrl.create(OrdersListPage, {}, {cssClass: brand.name});
      this.modal.present();
      this.modal.onDidDismiss(() => {
        this.inOrdersList.next(false);
        this.modal = undefined;
      });
    });
  }

  showOrderDetail(order) {
    this.inOrdersList.next(true);
    this.storage.get('current_brand').then((brand) => {
      this.detailModal = this.modalCtrl.create(OrderDetailPage, {orderId: order.id}, {cssClass: brand.name});
      this.detailModal.present();
      this.detailModal.onDidDismiss(() => {
        if (order.notification) {
          this.events.publish("orderList:get_data");
        }
        this.inOrdersList.next(false);
        this.detailModal = undefined;
      });
    });
  }

  getBackground(url) {
    return {
      "background-image": "url(" + url + "),linear-gradient(0deg,rgba(0,0,0,0.3),rgba(0,0,0,0.3))",//"url(" + url + ")",
    };
  }

  statusColor(statusValue) {
    let color;
    switch(statusValue) {
      case 'WAITING':
        color = 'dark';
        break;
      case 'CONFIRMED':
        color = 'success';
        break;
      case 'SENT':
        color = 'light';
        break;
      case 'RECEIVED':
        color = 'success';
        break;
      case 'REFUSED':
        color = 'default-purple';
        break;
      case 'CANCELED':
        color = 'danger';
        break;
    }
    return color;
  }

  ionViewDidLoad() {
    this.inOrdersList.next(true);
    this.events.publish('orderList:get_data');
  }

  disconnected() {
    this.navCtrl.setRoot(LoginPage, {
      disconnected: true
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/orders-list/orders-list.ts